import FoundationStatement from "components/CanaryFoundation/FoundationStatement";
import CanaryFountionBanner from "../components/CanaryFoundation/CanaryFountionBanner";

const CanaryFoundation = () => {
  return (
    <>
      <CanaryFountionBanner />
      <FoundationStatement />
    </>
  );
};

export default CanaryFoundation;
